import React from "react";
import { List } from "react-bootstrap-icons";
import { isAuthenticated, logout, getUser } from "../../utils/auth";
import { Dropdown } from "react-bootstrap";
import { PersonCircle } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";

const Topbar = ({ setSidebarOpen }) => {

  const navigate = useNavigate();
  const loggedIn = isAuthenticated();
  const user = getUser();

  const handleLogout = () => {
    logout();              // clear localStorage
    navigate("/login");  // redirect to admin login
  };

  return (
    <div className="topbar d-flex justify-content-between align-items-center px-3 py-2 shadow-sm bg-white">

      <div className="d-flex align-items-center">
        <List 
          className="menu-icon d-md-none me-3" 
          size={24}
          onClick={() => setSidebarOpen(true)} 
          style={{ cursor: "pointer" }}
        />
        <h5 className="mb-0">Admin Dashboard</h5>
      </div>

      {loggedIn && (
        <Dropdown align="end">
          <Dropdown.Toggle variant="light" className="d-flex align-items-center border-0 bg-white">
            <div className="text-end me-2">
              <div style={{ fontWeight: "500" }}>{user?.name}</div>
              {/* <small className="text-muted">Administrator</small> */}
            </div>
            <PersonCircle size={32} />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={handleLogout}>
              Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      )}

    </div>
  );
};

export default Topbar;